<div class="-homepage-container">
  <content-viewer 
  *ngIf="body" 
  [content]="body" 
  (docRendered)="handleDocRendered($event)">
  </content-viewer>
</div>